import { useMemo } from 'react';
import { makeRootClassName, makeBEM } from '../../../../utils';
export var useDatePickerTimeSelectorClassNames = function useDatePickerTimeSelectorClassNames(classPrefix, className) {
  return useMemo(function () {
    return {
      Root: makeRootClassName(classPrefix, className),
      Clock: makeBEM(classPrefix, 'Clock'),
      InputHours: "".concat(makeBEM(classPrefix, 'Input'), " ").concat(makeBEM(classPrefix, 'InputHours')),
      InputMinutes: "".concat(makeBEM(classPrefix, 'Input'), " ").concat(makeBEM(classPrefix, 'InputMinutes')),
      ButtonAM: "".concat(makeBEM(classPrefix, 'Button'), " ").concat(makeBEM(classPrefix, 'ButtonAM')),
      ButtonPM: "".concat(makeBEM(classPrefix, 'Button'), " ").concat(makeBEM(classPrefix, 'ButtonPM')),
      TimeSeparatorIcon: makeBEM(classPrefix, 'TimeSeparatorIcon'),
      DayPeriodSelector: makeBEM(classPrefix, 'DayPeriodSelector')
    };
  }, [classPrefix, className]);
};